module.exports = __webpack_public_path__ + "img/wxCode2.69a75cd7.png";